/* eslint-disable no-lonely-if */
/* eslint-disable camelcase */
import get from 'lodash/get';
import { ColourConfig } from 'src/javascript/components/fseManagementSystem/utils/colourConfig';

// dotFlag represents if we want to consider merchant_status for dots on card and detailing page
const getColourHashCode = (merchantData, dotFlag) => {
  const merchant_status = get(
    merchantData,
    'merchant_status',
    '',
  ).toLowerCase();
  const explicitAssigned = get(merchantData, 'explicitAssigned', false);
  const urgentSupportMessage = get(merchantData, 'urgentSupportMessage', '');
  const isClosed = get(merchantData, 'isClosed', false);
  let colourHashCode = '';
  if (merchant_status === '') {
    colourHashCode = ColourConfig.default;
  } else {
    // this check is added so that for urgent support black colour is shown
    if (explicitAssigned && urgentSupportMessage && dotFlag && !isClosed) {
      colourHashCode = ColourConfig.black;
    } else {
      colourHashCode = !ColourConfig[`${merchant_status.toLowerCase()}`]
        ? merchant_status
        : ColourConfig[`${merchant_status.toLowerCase()}`];
    }
  }
  return colourHashCode;
};
export default getColourHashCode;
